import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import { BIconDownload } from 'bootstrap-vue';

@Component({
  name: 'bpc-display-field-document',
  components: {
    'b-icon-download': BIconDownload,
  },
})
export default class DisplayFieldDocument extends mixins(AbstractDisplayField) {
  get url() {
    let url;

    if (this.value instanceof Array) {
      url = this.value[0].url;
    } else if (this.value instanceof Object) {
      url = this.value.url;
    } else {
      url = this.value;
    }

    return url;
  }
}
